/**
 * parad-cart-remove.js
 * Croix de suppression d'une ligne de panier, tiroir et page /cart.
 *
 * Markup : snippets/cart-item.liquid (`.parad-remove`, attribut data-parad-remove).
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * CE QUE ÇA REMPLACE
 * ─────────────────────────────────────────────────────────────────────────────
 * Le thème rendait un lien texte « Retirer » vers /cart/change?id=…&quantity=0,
 * c'est-à-dire une navigation complète : sur /cart la page se rechargeait, et
 * dans le tiroir le lien était purement et simplement masqué
 * (`.drawer .cart__remove{display:none}`, theme.css.liquid l. 12581). Résultat,
 * on ne pouvait pas retirer un article depuis le tiroir autrement qu'en
 * descendant sa quantité à zéro avec « − ».
 *
 * Ici, le clic est intercepté et rebranché sur le mécanisme AJAX du thème.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * ⚠️  LA QUANTITÉ DOIT ÊTRE LA CHAÎNE '0', PAS LE NOMBRE 0
 * ─────────────────────────────────────────────────────────────────────────────
 * theme.js l. 1843, dans CartForm.quantityChanged :
 *
 *     if (!key || !qty) { return; }
 *
 * Avec le nombre 0, `!qty` vaut true : le gestionnaire sort sans rien faire et
 * la croix ne supprime rien, en silence. Avec la chaîne '0', `!'0'` vaut false
 * et la suppression a lieu.
 *
 * Ce n'est pas un contournement de notre part : c'est exactement ce que fait le
 * thème. theme.QtySelector (l. 3081) lit `min` en ATTRIBUT HTML —
 * `this.minValue = this.input.getAttribute('min') || 1` — donc une chaîne, puis
 * `_change()` affecte `qty = this.minValue` quand on descend à la borne. Le
 * bouton « − » à une unité envoie donc lui aussi la chaîne '0'. On s'aligne.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * DÉGRADATION
 * ─────────────────────────────────────────────────────────────────────────────
 * La croix est un vrai lien portant le même href que l'ancien « Retirer ». Si
 * ce script n'est pas chargé, ou si la ligne ou le formulaire ne sont pas
 * trouvés, on ne fait rien : le navigateur suit le lien et l'article est retiré
 * avec un rechargement de page. Comportement d'avant, jamais une action perdue.
 */
(function () {
  'use strict';

  if (window.paradCartRemove) {
    return;
  }
  window.paradCartRemove = true;

  // Écouteur unique et délégué : les lignes de panier sont reconstruites à
  // chaque mise à jour (CartForm.cartMarkup vide puis réinjecte
  // `[data-products]`), un écouteur posé sur les croix elles-mêmes serait perdu
  // au premier changement de quantité.
  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target || !target.closest) {
      return;
    }

    var button = target.closest('[data-parad-remove]');
    if (!button) {
      return;
    }

    var item = button.closest('.cart__item');
    // Le namespace de l'évènement dépend de l'emplacement : `.cart-page` sur
    // /cart, `.cart-cart-drawer` dans le tiroir (theme.js l. 1687 :
    // `this.namespace = '.cart-' + form.dataset.location`). Chaque CartForm
    // n'écoute que le sien.
    var form = button.closest('form[data-location]');

    if (!item || !form) {
      return; // on laisse le lien faire son travail
    }

    var key = item.getAttribute('data-key');
    if (!key) {
      return;
    }

    evt.preventDefault();

    document.dispatchEvent(
      new CustomEvent('cart:quantity.cart-' + form.dataset.location, {
        detail: [key, '0', item]
      })
    );
  });
})();
